export function isLoading(state: any) {
  return (
    state.matches('loading') ||
    state.matches('loadingProspectList') ||
    state.matches('loadingProspects') ||
    state.matches('loadingProspectLists')
  );
}

export const hasAnyFilters = ({
  personQuery,
  companyQuery,
}: {
  companyQuery: Record<string, string[] | null>;
  personQuery: Record<string, string[] | null>;
}) => {
  const hasCompanyFilters = Object.values(companyQuery).some(
    (value) => value && value.length > 0,
  );
  const hasPersonFilters = Object.values(personQuery).some(
    (value) => value && value.length > 0,
  );

  return hasCompanyFilters || hasPersonFilters;
};
